import { StudentResultAnswerStates } from "../helpers/StudentResultModel";

export enum TeacherCommentTones {
    GREEN = "GREEN",
    RED = "RED",
    GREY = "GREY",
}

export interface TeacherCommentStyles {
    border: string;
    text: string;
}

/**
 * The bubble echoes the verdict of the answer it sits under. Only a clear right or wrong is coloured;
 * a partial verdict and a blank both read as neutral, so the comment does not overstate them.
 */
export const getTeacherCommentTone = (state: StudentResultAnswerStates): TeacherCommentTones => {
    switch (state) {
        case StudentResultAnswerStates.CORRECT:
            return TeacherCommentTones.GREEN;
        case StudentResultAnswerStates.INCORRECT:
            return TeacherCommentTones.RED;
        default:
            return TeacherCommentTones.GREY;
    }
};

const teacherCommentStylesByTone: Record<TeacherCommentTones, TeacherCommentStyles> = {
    [TeacherCommentTones.GREEN]: { border: "border-p6-green-mid", text: "text-forest-green-900" },
    [TeacherCommentTones.RED]: { border: "border-p6-red-brighter", text: "text-p6-red" },
    [TeacherCommentTones.GREY]: { border: "border-p6-grey-mid", text: "text-p6-grey-dark" },
};

export const getTeacherCommentStyles = (tone: TeacherCommentTones): TeacherCommentStyles =>
    teacherCommentStylesByTone[tone];
